interface FormatTableNameOptions {
  includeGroupName?: boolean
}

export const formatTableName = (
  table: { name: string; tableGroup?: { name?: string } | null },
  options: FormatTableNameOptions = {},
) => {
  const { includeGroupName = true } = options
  const groupName = includeGroupName ? table.tableGroup?.name : null
  return groupName ? `${table.name} - ${groupName}` : table.name
}
